import CATEGORIES from "../data/categories";
import { useApp } from "../context/AppContext";

const SOCIAL_LINKS = [
  { label: "fb", href: "https://www.facebook.com/privateconvenience" },
  { label: "ig", href: "https://www.instagram.com/private_convenience/" },
  { label: "tw", href: "https://twitter.com/PrivateConvenience" },
];

const STORE_HOURS = [
  { day: "Mon – Fri", time: "6:30 am – 11:00 pm" },
  { day: "Saturday",  time: "7:00 am – 11:00 pm"  },
  { day: "Sunday",    time: "8:00 am – 11:00 pm"  },
];

export default function Footer() {
  const { navigate, setSearch } = useApp();

  const goTo = (page, cat) => {
    setSearch("");
    navigate(page, cat);
  };

  return (
    <footer>
      <div className="footer-top">

        {/* ── Brand column ── */}
        <div>
          <div className="f-brand-name">
            Private's <span>Convenience</span>
          </div>
          <p className="f-brand-desc">
            London's most unique variety store, family run since 2014. Rare
            imports, snacks, fireworks and more!
          </p>
          <div className="f-socials">
            {SOCIAL_LINKS.map(({ label, href }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noreferrer"
                className="f-social-btn"
              >
                {label}
              </a>
            ))}
          </div>
        </div>

        {/* ── Shop column ── */}
        <div className="footer-col">
          <h4>Shop</h4>
          <ul>
            {CATEGORIES.filter((c) => c.id !== "all").map((cat) => (
              <li key={cat.id}>
                <button onClick={() => goTo("products", cat.id)}>
                  {cat.icon} {cat.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* ── Info column ── */}
        <div className="footer-col">
          <h4>Info</h4>
          <ul>
            <li><button onClick={() => goTo("home")}>Home</button></li>
            <li><button onClick={() => goTo("about")}>About Us</button></li>
            <li><button onClick={() => goTo("contact")}>Contact Us</button></li>
            <li>
              <a
                href="https://www.google.com/maps/place/London,+ON/data=!4m2!3m1!1s0x882ef20ea88d9b0b:0x28c7d7699a056b95?sa=X&ved=1t:242&ictx=111"
                target="_blank"
                rel="noreferrer"
              >
                Get Directions ↗
              </a>
            </li>
            <li>
              <a href="https://www.facebook.com/privateconvenience" target="_blank" rel="noreferrer">
                Facebook ↗
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/private_convenience/" target="_blank" rel="noreferrer">
                Instagram ↗
              </a>
            </li>
          </ul>
        </div>

        {/* ── Hours column ── */}
        <div className="footer-col">
          <h4>Store Hours</h4>
          <ul className="f-hours-list">
            {STORE_HOURS.map(({ day, time }) => (
              <>
                <li key={day}><strong>{day}</strong></li>
                <li key={time} style={{ marginBottom: 6 }}>{time}</li>
              </>
            ))}
            <li style={{ marginTop: 10, fontSize: "0.72rem", fontStyle: "italic" }}>
              ⚠️ Subject to change on holidays.
            </li>
          </ul>
        </div>

      </div>

      {/* ── Bottom bar ── */}
      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <p>
            © {new Date().getFullYear()} Private Convenience · London ON · ###-###-####
          </p>
          <div className="footer-bottom-links">
            <button onClick={() => goTo("about")}>About</button>
            <button onClick={() => goTo("contact")}>Contact</button>
          </div>
        </div>
      </div>
    </footer>
  );
}
